<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="title-container" v-bind:style="{ background: '#4A6E89' }">
                <h2 class="search-title">{{ searchboxheadlineflighthelp[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-search"></i>
            </div>

            <section id="content" style="padding-top: 20px; background-color: #fff;">
                <div id="main">
                    <div class="contact-address block" style="margin-left: 20px; margin-right: 20px;">
                        <h4>{{ hellotext1[getCurrentLocale] }}</h4>
                        <p v-html="hellotext2[getCurrentLocale]"></p>
                        <p v-html="hellotext3[getCurrentLocale]"></p>
                        <div class="alert alert-help">
                            <span v-html="hellotext4[getCurrentLocale]"></span>
                            <span class="close"></span>
                        </div>

                        <hr>

                        <h5 class="title">{{ when[getCurrentLocale] }}</h5>
                        <div class="row">
                            <div class="col-xs-6">
                                <label>{{ form_bookingno[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                                <input type="text" class="input-text full-width"
                                    :class="{ invalid : $v.input_bookingno.$error }"
                                    @input="$v.input_bookingno.$touch()"
                                    v-model="input_bookingno"
                                    id="'input_bookingno"
                                    name="input_bookingno" value="" placeholder="E.G.: MB4K2VUH" style="text-transform: uppercase;" />
                                <!-- >>> 'errormsg', bookingno -->
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.minLength">{{ errmsg_min_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.maxLength">{{ errmsg_max_bookingno[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_bookingno.$dirty && !$v.input_bookingno.lettersandnumbers">{{ errmsg_lettersandnumbers[getCurrentLocale] }}</p>
                                <!-- <<< 'errormsg', bookingno -->
                            </div>

                            <div class="col-xs-6">
                                <label>{{ form_surname[getCurrentLocale] }}:<span style="color: red; font-size:14px;">*</span></label>
                                <input type="text" class="input-text full-width"
                                    :class="{ invalid : $v.input_surname.$error }"
                                    @input="$v.input_surname.$touch()"
                                    v-model="input_surname"
                                    id="'input_surname"
                                    name="input_surname" value="" placeholder="E.G.: Mustermann" style="text-transform: uppercase;" />
                                <!-- >>> 'errormsg', input_surname -->
                                <p class="errormsg" v-if="$v.input_surname.$dirty && !$v.input_surname.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_surname.$dirty && !$v.input_surname.minLength">{{ errmsg_min_surname[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_surname.$dirty && !$v.input_surname.maxLength">{{ errmsg_max_surname[getCurrentLocale] }}</p>
                                <p class="errormsg" v-if="$v.input_surname.$dirty && !$v.input_surname.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                <!-- <<< 'errormsg', input_surname -->
                            </div>
                        </div>

                        <br />

                        <p-check class="p-svg p-round p-pulse" color="success" value="ABB" v-model="checkedBoxes">
                            <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                <path d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" style="stroke: white;fill:white" />
                            </svg>

                        </p-check>
                        <span class="skin-color" style="font-size: 1.0833em;" >{{ checkboxtext[getCurrentLocale] }}</span>

                        <hr>

                        <!-- >>> Submit -->
                        <a class="button btn-large uppercase full-width silver" v-if="(!checkValidity() && getFlagServicesBookingnoLoginIsReadyForLogin === false) || (!checkValidity() && getFlagServicesBookingnoLoginIsReadyForLogin === true)">{{ getbookinno[getCurrentLocale] }}</a>
                        <button type="submit" class="btn-large icon-check-srvcs uppercase full-width" v-if="checkValidity() && getFlagServicesBookingnoLoginIsReadyForLogin === true" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }"  v-bind:style="{ background: '#4A6E89' }">{{ getbookinno[getCurrentLocale] }}</button>
                    </div>
                </div>
            </section>
        </form>
    </div>
</template>

<script>
    import { helpers, required, minLength, maxLength, numeric, alphaNum, email } from 'vuelidate/lib/validators';
    const letterspaces = helpers.regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i);    /* Validator */
    const numericspaces = helpers.regex('numericspaces', /^[0-9+/\s]+$/i);       /* Validator */
    const lettersandnumbers = helpers.regex('lettersandnumbers', /^[A-Za-z0-9]+$/i);    /* Validator */

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlineflighthelp: {
                    en: 'Find Booking and add services',
                    de: 'Buchung finden und Services hinzubuchen',
                },
                searchboxheadlineflights2: {
                    en: 'Discover the world with SUNDAIR!',
                    de: 'Entdecke die Welt mit SUNDAIR!',
                },

                hellotext1 : {
                    en: 'Create your own journey',
                    de: 'Gestalten Sie Ihre Reise selbst',
                },
                hellotext2 : {
                    en: 'Here you can easily and conveniently add services for your already booked flight with your tour operator. To do so, please enter your booking number and the surname you gave when you made your booking.',
                    de: 'Hier können Sie für Ihren bereits gebuchten Flug bei Ihrem Reiseveranstalter bequem und einfach Services hinzufügen. Dafür geben Sie bitte Ihre Buchungsnummer und Ihren Nachnamen, den Sie in der Buchung angegeben haben ein.',
                },
                hellotext3 : {
                    en: 'You will find your booking number in your booking confirmation from your tour operator.',
                    de: 'Ihre Buchungsnummer finden Sie in Ihrer Buchungsbestätigung von Ihrem Reiseveranstalter.',
                },
                hellotext4 : {
                    en: 'We offer the following services:<br /><br /><ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;"><li>View your flights</li><li>Seat Reservation</li><li>Additional baggage (excess, special and sports baggage)</li><li>Premium Meals</li><li>Further services</li>',
                    de: 'Wir bieten Ihnen folgende Services:<br /><br /><ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;"><li>Ihre Flüge einsehen</li><li>Sitzplatzreservierung</li><li>Zusätzliches Gepäck (Über-, Sonder- und Sportgepäck)</li><li>Premium Mahlzeiten</li><li>Weitere Serviceleistungen</li>',
                },
                checkboxtext : {
                    en: 'I hereby confirm that I am authorised to manage this booking on behalf of other passengers or if I am the only passenger',
                    de: 'Hiermit bestätige ich, dass ich berechtigt bin, diese Buchung im Namen anderer Passagiere zu verwalten oder wenn ich der einzige Passagier bin.',
                },
                // ----------------------------------
                when: {
                    en: 'Your booking data',
                    de: 'Ihre Buchungsdaten',
                },
                form_bookingno: {
                    en: 'Your bookingno',
                    de: 'Ihre Buchungsnummer',
                },
                form_surname: {
                    en: 'Your surname',
                    de: 'Ihr Familienname',
                },
                // ----------------------------------
                getbookinno: {
                    en: 'FIND YOUR JOURNEY',
                    de: 'IHRE REISE FINDEN',
                },
                // >>> --------------------------
                checkedBoxes: [],
                // >>> --------------------------
                input_bookingno: '', // 8C007307...., 2772630
                input_surname: '', // WIEMANN
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                // >>> --------------------------
               errmsg_letterspaces: {
                    en: 'Letters, "-" and spaces are allowed.',
                    de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.',
                },
               errmsg_lettersandnumbers: {
                    en: 'Letters and Numberss are allowed.',
                    de: 'Erlaubt sind Buchstaben und Zahlen.',
                },
                // >>> --------------------------
                errmsg_min_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_max_bookingno: {
                    en: 'Allowed length: 6-12 characters.',
                    de: 'Erlaubte Länge: 6-12 Zeichen.',
                },
                errmsg_min_surname: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                errmsg_max_surname: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                // currentLocale: 'de',
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Validations */
        validations: {

            // >>> bookingno --------------------
            input_bookingno: {
                required: required,
                minLength: minLength(6),
                maxLength: maxLength(12),
                lettersandnumbers: lettersandnumbers
            },
            input_surname: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                letterspaces: letterspaces
            },

        }, // eo validations{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getFlagServicesBookingnoLoginIsReadyForLogin',
                'get_ServicesUsersSearchDataBookingno',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            checkedBoxes: function() {

                if (this.checkedBoxes.length === 1)  {
                    this.actn_FlagServicesBookingnoLoginIsReadyForLogin(true);
                } else {
                    this.actn_FlagServicesBookingnoLoginIsReadyForLogin(false);
                }

            } // eo function checkedBoxes()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytopushpassengers' ('All Calls done ...').
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> shared/forms/BookingnoTab.vue >>> created');
            me.actn_set_stateReset('services');
            eventBus.$on('readytoshoworiginalbooking', this.onEmit_ReadyToShowOriginalBooking);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Coming back from Payment? Then fill out again.
        * Note:
        *
        */
		mounted: function () {

            if (this.get_ServicesUsersSearchDataBookingno !== null) {
                this.input_bookingno = this.get_ServicesUsersSearchDataBookingno.bookingCode;
                this.input_surname = this.get_ServicesUsersSearchDataBookingno.lastName;

                window.scrollTo(0, 0);
            }

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> shared/forms/BookingnoTab.vue >>> beforeDestroy');
            eventBus.$off('readytoshoworiginalbooking', this.onEmit_ReadyToShowOriginalBooking);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_stateReset', // set:
                'actn_set_areWeInServicesBookingNoMode', // set:
                'actn_call_listOriginalBooking', // Call: 'get original booking'
                'actn_FlagSharedShowFlightSearchResults', // Control Flag
                'actn_FlagServicesShowBookingnoSearchResults', // Control Flag
                'actn_FlagServicesBookingnoLoginIsReadyForLogin', // Control Flag
                'actn_setServicesUsersSearchDataBookingno', // remember in state
                'actn_setServicesBookingnoSearchResults', // remember in state
            ]),


            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/registration/overview/'
            *
            * Desc: Getting original Booking Data via Bookingno.
            * Note:
            * Note: Set 'Are we in 'Services Bookingno' Mode?
            * Note: New: Axios Call is here managed in VUEX.
            *
            */
            call_listOriginalBooking: function(params) {

                var me = this;


                me.$toc('>>> shared/forms/BookingnoTab.vue >>> call_listOriginalBooking');
                this.actn_set_stateReset('services');                           // state reset
                this.actn_set_areWeInServicesBookingNoMode(true);               // from here on ... 'we are in services bookinno mode'

                this.actn_call_listOriginalBooking(params);                     // Call

            }, // eo function call_listOriginalBooking()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: 'Overview Form' gets (not really) submitted.
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @return
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    myBookingnoParams = {};


                me.$toc('>>> shared/forms/BookingnoTab.vue >>> onSubmit');
                myBookingnoParams.bookingCode = this.input_bookingno.toUpperCase();
                myBookingnoParams.lastName = this.input_surname.toUpperCase();

                me.actn_FlagSharedShowFlightSearchResults(false);               // Hide 'Section'
                me.actn_FlagServicesShowBookingnoSearchResults(false);          // Hide 'Section'

                this.actn_setServicesUsersSearchDataBookingno(myBookingnoParams); // remember in state

                this.call_listOriginalBooking(myBookingnoParams);

            }, // eo function onSubmit()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowOriginalBooking()
            *
            * Desc: Handle
            * Note:
            *
            */
            onEmit_ReadyToShowOriginalBooking: function() {

                let me = this,
                    options = {};



                me.$toc('>>> shared/forms/BookingnoTab.vue >>> onEmit_ReadyToShowOriginalBooking');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Showing/Scrolling ---------------------------------------
                me.actn_FlagServicesShowBookingnoSearchResults(true);           // Show 'Section'
                setTimeout(function() {
                    me.$scrollTo('#contentElementBookingno', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToShowOriginalBooking()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * checkValidity()
            *
            * Desc:
            * Note:
            *
            * @param
            * @return {Array}
            */
            checkValidity: function() {

                var me = this,
                    formIsValid = false;


                me.$toc('>>> shared/forms/BookingnoTab.vue >>> checkValidity');
                if (this.input_bookingno !== '') {
                    if (!me.$v.input_bookingno.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                } else {
                    formIsValid = false;
                }

                if (formIsValid === true) {
                    if (this.input_surname !== '') {
                        if (!me.$v.input_surname.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    } else {
                        formIsValid = false;
                    }
                }



                // Last Check: Checkbox -------------------
                if (formIsValid === true) {
                    if (this.getFlagServicesBookingnoLoginIsReadyForLogin === true) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }

                return formIsValid;

            }, // eo function checkValidity()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-box.style5 > i {
        background: #ec008b;
    }
    .icon-box.style5 {
        background: #f5f5f5;
    }
    .alert.alert-help {
        background: #dcecf6;
        color: #406f8c;
    }
    .alert .close,
    .info-box .close {
        color: #406f8c;
    }

    .icon-check-srvcs {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check-srvcs:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4A6E89;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/forms/BookingnoTab.vue